import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { hideModal } from '../../../../../redux/modules/modal';
import { globalRequirementTemplateBuilder } from '../../../../../redux/reducer';

function ArchivePublishedTemplate({ templateId }) {
  const dispatch = useDispatch();
  const { currentFolder } = useSelector(globalRequirementTemplateBuilder.selectRequirementTemplateFolders);

  const onSubmit = async evt => {
    evt.preventDefault();

    await dispatch(globalRequirementTemplateBuilder.updateRequirementTemplate(templateId, {
      requirement_template_folder_id: null,
      archived_at: new Date()
    }));

    dispatch(globalRequirementTemplateBuilder.listFolderRequirementTemplates(currentFolder));
    dispatch(globalRequirementTemplateBuilder.listRequirementTemplateFolders());
    dispatch(hideModal());
  };

  return (
    <form id="archivePublishedTemplate" onSubmit={onSubmit}>
      <Box>Archived templates can be viewed and reactivated from the Archived folder</Box>
    </form>
  );
}

ArchivePublishedTemplate.propTypes = {
  templateId: PropTypes.number.isRequired
};

export default ArchivePublishedTemplate;
